export default __webpack_public_path__ + "static/media/pcvassembly.5d1a5a06.png";